import { type SlotEntry } from 'customer-flows/components/_config/registry'
import { heros } from './hero'
import { footers } from './footer'

export const slots = [
  ...heros,
  ...footers
] satisfies SlotEntry[]
